const PROGRESS_STAGES = [
  { key: 'ordered', label: 'Ordered' },
  { key: 'packed', label: 'Order Ready' },
  { key: 'in_transit', label: 'In Transit' },
  { key: 'out_for_delivery', label: 'Out for Delivery' },
  { key: 'delivered', label: 'Delivered' },
];
const MOBILE_PROGRESS_LABELS = {
  ordered: 'Ordered',
  packed: 'Ready',
  in_transit: 'Transit',
  out_for_delivery: 'Out',
  delivered: 'Delivered',
};
const PROGRESS_ICONS = {
  ordered: `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M17 18c-.551 0-1-.449-1-1 0-.551.449-1 1-1 .551 0 1 .449 1 1 0 .551-.449 1-1 1zM4 17c0 .551-.449 1-1 1-.551 0-1-.449-1-1 0-.551.449-1 1-1 .551 0 1 .449 1 1zM17.666 5.841L16.279 10H4V4.133l13.666 1.708zM17 14H4v-2h13a1 1 0 0 0 .949-.684l2-6a1 1 0 0 0-.825-1.308L4 2.117V1a1 1 0 0 0-1-1H1a1 1 0 0 0 0 2h1v12.184A2.996 2.996 0 0 0 0 17c0 1.654 1.346 3 3 3s3-1.346 3-3c0-.353-.072-.686-.184-1h8.368A2.962 2.962 0 0 0 14 17c0 1.654 1.346 3 3 3s3-1.346 3-3-1.346-3-3-3z"></path></svg>
  `,
  packed: `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
<path d="M19.901 4.581c-.004-.009-.002-.019-.006-.028l-2-4A1.001 1.001 0 0 0 17 0H3c-.379 0-.725.214-.895.553l-2 4c-.004.009-.002.019-.006.028A.982.982 0 0 0 0 5v14a1 1 0 0 0 1 1h18a1 1 0 0 0 1-1V5a.982.982 0 0 0-.099-.419zM2 18V6h7v1a1 1 0 0 0 2 0V6h7v12H2zM3.618 2H9v2H2.618l1-2zm13.764 2H11V2h5.382l1 2zM9 14H5a1 1 0 0 0 0 2h4a1 1 0 0 0 0-2m-4-2h2a1 1 0 0 0 0-2H5a1 1 0 0 0 0 2"></path>
    </svg>
  `,
  in_transit: `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20">
<path d="M17.816 14c-.415-1.162-1.514-2-2.816-2s-2.4.838-2.816 2H12v-4h6v4h-.184zM15 16c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM5 16c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM2 4h8v10H7.816C7.4 12.838 6.302 12 5 12s-2.4.838-2.816 2H2V4zm13.434 1l1.8 3H12V5h3.434zm4.424 3.485l-3-5C16.678 3.185 16.35 3 16 3h-4a1 1 0 0 0-1-1H1a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h1.185C2.6 17.162 3.698 18 5 18s2.4-.838 2.816-2h4.37c.413 1.162 1.512 2 2.814 2s2.4-.838 2.816-2H19a1 1 0 0 0 1-1V9c0-.18-.05-.36-.142-.515z"></path>
    </svg>
  `,
  out_for_delivery: `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 21 21">
<path d="M10 0C5.589 0 2 3.589 2 8c0 7.495 7.197 11.694 7.504 11.869a.996.996 0 0 0 .992 0C10.803 19.694 18 15.495 18 8c0-4.412-3.589-8-8-8m-.001 17.813C8.478 16.782 4 13.296 4 8c0-3.31 2.691-6 6-6s6 2.69 6 6c0 5.276-4.482 8.778-6.001 9.813M10 10c-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2-.897 2-2 2m0-6C7.794 4 6 5.794 6 8s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4"></path>
    </svg>
  `,
  delivered: `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M10 18c-4.411 0-8-3.589-8-8s3.589-8 8-8 8 3.589 8 8-3.589 8-8 8m0-14c-3.309 0-6 2.691-6 6s2.691 6 6 6 6-2.691 6-6-2.691-6-6-6m-1 9a.997.997 0 0 1-.707-.293l-2-2a.999.999 0 1 1 1.414-1.414L9 10.586l3.293-3.293a.999.999 0 1 1 1.414 1.414l-4 4A.997.997 0 0 1 9 13"></path></svg>
  `,
};

const DEMO_RESPONSE = {
  success: true,
  order_number: '#71030',
  status: 'Delivered',
  status_code: 'delivered',
  tracking_number: 'LZ396913005CN',
  carrier: 'China Post / Australia Post',
  order_date: '2026-04-02T03:12:00Z',
  shipping_method: 'Standard shipping (free over $100)',
  estimated_delivery_by: '2026-04-21T13:30:00Z',
  shipped_to: {
    name: 'Jeanity Customer',
    address_line_1: '35 Down Street',
    city: 'Esk',
    region: 'Queensland',
    postal_code: '4312',
    country: 'Australia',
  },
  product: {
    title: "Women's Stretch Denim Wide Leg BBL Jeans - Slimming Fit",
    variant: 'Light Blue / M',
    image: 'https://cdn.shopify.com/s/files/1/0948/6411/6022/files/placeholder.png?v=1',
    url: '/collections/all',
  },
  map: {
    lat: -27.4705,
    lng: 153.026,
  },
  steps: [
    { title: 'Package Received', timestamp: '2026-04-12T16:09:00Z', location: 'Processing Center', status: 'complete' },
    { title: 'Departure from Processing Center', timestamp: '2026-04-12T18:38:00Z', location: 'Processing Center', status: 'complete' },
    { title: 'Handed over to export customs', timestamp: '2026-04-12T18:42:00Z', location: 'City', status: 'complete' },
    { title: 'Flight Departure', timestamp: '2026-04-13T18:56:00Z', location: 'International Hub', status: 'complete' },
    { title: 'Arrived at Destination', timestamp: '2026-04-17T11:23:00Z', location: 'Australia', status: 'complete' },
    { title: 'Out for Delivery', timestamp: '2026-04-21T07:20:00Z', location: 'Brisbane', status: 'complete' },
    { title: 'Delivered', timestamp: '2026-04-21T13:30:00Z', location: 'Esk', status: 'current' },
  ],
};

function text(value, fallback = '') {
  if (value === null || value === undefined) return fallback;
  return String(value);
}

function escapeRegex(value) {
  return text(value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function cleanText(value) {
  return text(value)
    .replace(/\s{2,}/g, ' ')
    .replace(/\s+,/g, ',')
    .replace(/,\s*,/g, ', ')
    .replace(/\(\s*\)/g, '')
    .replace(/\s+\)/g, ')')
    .replace(/\(\s+/g, '(')
    .trim()
    .replace(/^[-,.;: ]+|[-,.;: ]+$/g, '')
    .trim();
}

function parseBlockedPhrases(input) {
  return text(input)
    .split(',')
    .map((item) => item.trim())
    .filter(Boolean);
}

function parseReplacementRules(input) {
  const rules = [];
  const lines = text(input)
    .split(/\r?\n/)
    .map((line) => line.trim())
    .filter(Boolean);

  lines.forEach((line) => {
    const separatorIndex = line.indexOf('=>');
    if (separatorIndex < 0) return;
    const from = line.slice(0, separatorIndex).trim();
    const to = line.slice(separatorIndex + 2).trim();
    if (!from) return;
    rules.push({ from, to });
  });

  return rules;
}

function sanitizeDisplayText(value, options = {}) {
  let output = text(value);
  if (!output) return '';

  const redactCountry = text(options.redactCountry).trim();
  const facilityLabel = text(options.facilityLabel).trim() || 'Jeanity Warehouse';

  if (redactCountry) {
    const countryPattern = new RegExp(`\\b${escapeRegex(redactCountry)}\\b`, 'gi');
    output = output.replace(countryPattern, '');
  }
  output = output.replace(/\[object\s+Object\]/gi, '');
  output = output.replace(/\bmainland\s*china\b/gi, '');
  output = output.replace(/\bmainland\b/gi, '');
  output = output.replace(/\bchina\b/gi, '');
  output = output.replace(/\bcn\b/gi, '');

  output = output.replace(/\borigin\s+facility\b/gi, facilityLabel);
  output = output.replace(/\borigin\s+international\s+airport\b/gi, `${facilityLabel} Dispatch Hub`);
  output = output.replace(/\bcountry\s+of\s+origin\b/gi, 'dispatch facility');
  output = output.replace(/\borigin\s+customs\s+declaration\b/gi, 'warehouse customs declaration');

  const blockedPhrases = Array.isArray(options.blockedPhrases) ? options.blockedPhrases : [];
  blockedPhrases.forEach((phrase) => {
    const pattern = new RegExp(escapeRegex(phrase), 'gi');
    output = output.replace(pattern, '');
  });

  const replacementRules = Array.isArray(options.replacementRules) ? options.replacementRules : [];
  replacementRules.forEach((rule) => {
    if (!rule?.from) return;
    const pattern = new RegExp(escapeRegex(rule.from), 'gi');
    output = output.replace(pattern, text(rule.to));
  });

  return cleanText(output);
}

function formatDate(value) {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return text(value);
  return d.toLocaleString(undefined, {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
  });
}

function formatShortDate(value) {
  if (!value) return '';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return '';
  return d.toLocaleDateString(undefined, {
    month: 'short',
    day: '2-digit',
  });
}

function inferProgressKeyFromTitle(title) {
  const t = text(title).toLowerCase();
  if (t.includes('deliver')) return 'delivered';
  if (t.includes('out for delivery')) return 'out_for_delivery';
  if (t.includes('transit') || t.includes('flight') || t.includes('dispatch') || t.includes('carrier')) return 'in_transit';
  if (t.includes('ready') || t.includes('packed') || t.includes('processing') || t.includes('customs')) return 'packed';
  return 'ordered';
}

function buildAddress(shippedTo) {
  if (!shippedTo) return '';
  return [
    shippedTo.name,
    shippedTo.address_line_1,
    [shippedTo.city, shippedTo.region].filter(Boolean).join(', '),
    [shippedTo.postal_code, shippedTo.country].filter(Boolean).join(' '),
  ]
    .filter(Boolean)
    .join('\n');
}

function stageIndexFromStatus(statusCode) {
  const code = text(statusCode).toLowerCase();
  if (code.includes('deliver')) return 4;
  if (code.includes('out_for_delivery') || code.includes('out-for-delivery')) return 3;
  if (code.includes('transit')) return 2;
  if (code.includes('pack') || code.includes('ready')) return 1;
  return 0;
}

function renderProgress(root, data) {
  const list = root.querySelector('[data-progress]');
  if (!list) return;
  list.innerHTML = '';

  const currentIndex = stageIndexFromStatus(data.status_code);
  const stageDates = {};
  (data.steps || []).forEach((step) => {
    const key = inferProgressKeyFromTitle(step?.title);
    if (!stageDates[key] && step?.timestamp) {
      stageDates[key] = step.timestamp;
    }
  });

  list.style.setProperty('--jt-filled-width', `${currentIndex * 20}%`);

  PROGRESS_STAGES.forEach((stage, idx) => {
    const li = document.createElement('li');
    li.className = 'jeanity-tracking__progress-item';
    if (idx < currentIndex) li.classList.add('is-complete');
    if (idx === currentIndex) li.classList.add('is-current');

    const icon = document.createElement('span');
    icon.className = 'jeanity-tracking__progress-icon';
    icon.innerHTML = PROGRESS_ICONS[stage.key] || '';
    li.appendChild(icon);

    const label = document.createElement('span');
    label.className = 'jeanity-tracking__progress-label';
    const isMobile = window.matchMedia('(max-width: 889px)').matches;
    label.textContent = isMobile ? MOBILE_PROGRESS_LABELS[stage.key] || stage.label : stage.label;
    li.appendChild(label);

    const date = document.createElement('span');
    date.className = 'jeanity-tracking__progress-date';
    date.textContent = formatShortDate(stageDates[stage.key]);
    li.appendChild(date);

    list.appendChild(li);
  });
}

function buildTimelineItem(step, options = {}) {
  const item = document.createElement('article');
  item.className = 'jeanity-tracking__timeline-item';
  if (step.status === 'current') item.classList.add('is-current');

  const time = document.createElement('div');
  time.className = 'jeanity-tracking__timeline-time';
  time.textContent = formatDate(step.timestamp);
  item.appendChild(time);

  const title = document.createElement('h4');
  title.className = 'jeanity-tracking__timeline-title';
  title.textContent = sanitizeDisplayText(step.title, options);
  item.appendChild(title);

  const sub = document.createElement('p');
  sub.className = 'jeanity-tracking__timeline-subtitle';
  sub.textContent = [
    sanitizeDisplayText(step.location, options),
    sanitizeDisplayText(step.description, options),
  ]
    .filter(Boolean)
    .join(' | ');
  item.appendChild(sub);

  return item;
}

function renderTimeline(root, steps = [], options = {}) {
  const container = root.querySelector('[data-timeline]');
  const toggleButton = root.querySelector('[data-timeline-full]');
  const modal = root.querySelector('[data-timeline-modal]');
  const modalBody = root.querySelector('[data-timeline-modal-body]');
  const modalClose = root.querySelector('[data-timeline-modal-close]');
  if (!container) return;
  container.innerHTML = '';

  const orderedSteps = [...steps].reverse();
  const isMobile = window.matchMedia('(max-width: 889px)').matches;
  const initialCount = Math.max(4, Number(root.dataset.mobileTimelineInitial || 8));
  const desktopPreviewCount = Math.max(initialCount, Number(root.dataset.timelinePreviewCount || 14));
  const previewCount = isMobile ? initialCount : desktopPreviewCount;

  orderedSteps.slice(0, previewCount).forEach((step) => {
    container.appendChild(buildTimelineItem(step, options));
  });

  if (!toggleButton) return;

  const hasOverflow = orderedSteps.length > previewCount;
  toggleButton.hidden = !hasOverflow;
  if (!hasOverflow) {
    toggleButton.textContent = 'View full history';
    return;
  }

  toggleButton.textContent = `View full history (${orderedSteps.length})`;
  toggleButton.onclick = () => {
    if (!modal || !modalBody) return;
    modalBody.innerHTML = '';
    orderedSteps.forEach((step) => {
      modalBody.appendChild(buildTimelineItem(step, options));
    });
    if (typeof modal.showModal === 'function') {
      modal.showModal();
    } else {
      modal.setAttribute('open', 'open');
    }
  };

  if (modalClose) {
    modalClose.onclick = () => {
      if (!modal) return;
      if (typeof modal.close === 'function') {
        modal.close();
      } else {
        modal.removeAttribute('open');
      }
    };
  }

  if (modal) {
    modal.onclick = (event) => {
      if (event.target !== modal) return;
      if (typeof modal.close === 'function') {
        modal.close();
      } else {
        modal.removeAttribute('open');
      }
    };
  }
}

function renderCarrierBadges(root, payload = {}, options = {}) {
  const wrap = root.querySelector('[data-carrier-badges]');
  const lastMileEl = root.querySelector('[data-carrier-last-mile]');
  if (!wrap || !lastMileEl) return;

  const lastMileCarrier = sanitizeDisplayText(payload?.carrier_details?.last_mile || '', options);
  const lastMileTrackingNumber = sanitizeDisplayText(payload?.carrier_details?.last_mile_tracking_number || '', options);
  const originalTrackingNumber = sanitizeDisplayText(payload?.tracking_number || '', options);
  const hasDifferentLastMileNumber = lastMileTrackingNumber
    && lastMileTrackingNumber.toLowerCase() !== originalTrackingNumber.toLowerCase();

  lastMileEl.hidden = !hasDifferentLastMileNumber;
  lastMileEl.innerHTML = '';

  if (hasDifferentLastMileNumber) {
    const labelEl = document.createElement('span');
    labelEl.className = 'jeanity-tracking__updated-tracking-label';
    labelEl.textContent = 'Updated Tracking #';
    lastMileEl.appendChild(labelEl);

    const carrierEl = document.createElement('span');
    carrierEl.className = 'jeanity-tracking__updated-tracking-carrier';
    carrierEl.textContent = lastMileCarrier;
    lastMileEl.appendChild(carrierEl);

    const number = document.createElement('span');
    number.className = 'jeanity-tracking__carrier-number';
    number.textContent = lastMileTrackingNumber;
    lastMileEl.appendChild(number);
  }

  wrap.hidden = !hasDifferentLastMileNumber;
}

function renderProduct(root, products) {
  const host = root.querySelector('[data-product]');
  if (!host) return;
  host.innerHTML = '';

  const productList = Array.isArray(products) ? products : (products ? [products] : []);
  if (!productList.length) {
    host.textContent = 'Product details unavailable.';
    return;
  }

  productList.forEach((product) => {
    const wrap = document.createElement(product.url ? 'a' : 'div');
    wrap.className = 'jeanity-tracking__product-item';
    if (product.url) {
      wrap.href = product.url;
      wrap.target = '_self';
      wrap.rel = 'noopener';
      wrap.style.textDecoration = 'none';
      wrap.style.color = 'inherit';
    }

    if (product.image) {
      const img = document.createElement('img');
      img.src = product.image;
      img.alt = text(product.title);
      img.loading = 'lazy';
      wrap.appendChild(img);
    }

    const meta = document.createElement('div');
    const name = document.createElement('div');
    name.textContent = text(product.title);
    meta.appendChild(name);

    if (product.variant) {
      const variant = document.createElement('small');
      variant.textContent = text(product.variant);
      variant.style.opacity = '0.75';
      meta.appendChild(variant);
    }

    wrap.appendChild(meta);
    host.appendChild(wrap);
  });
}

function renderMap(root, data) {
  const wrap = root.querySelector('[data-map-wrap]');
  const frame = root.querySelector('[data-map-frame]');
  if (!wrap || !frame) return;

  const lat = data?.map?.lat;
  const lng = data?.map?.lng;
  const zoom = Number(root.dataset.mapZoom || 7);
  if (lat && lng) {
    frame.src = `https://www.google.com/maps?q=${encodeURIComponent(`${lat},${lng}`)}&z=${zoom}&output=embed`;
    wrap.hidden = false;
    return;
  }

  const addressText = [
    data?.shipped_to?.address_line_1,
    data?.shipped_to?.city,
    data?.shipped_to?.region,
    data?.shipped_to?.country,
  ]
    .filter(Boolean)
    .join(', ');

  if (!addressText) {
    wrap.hidden = true;
    frame.removeAttribute('src');
    return;
  }

  frame.src = `https://www.google.com/maps?q=${encodeURIComponent(addressText)}&z=${zoom}&output=embed`;
  wrap.hidden = false;
}

function setMessage(root, msg, isError = false) {
  const el = root.querySelector('[data-tracking-message]');
  if (!el) return;
  el.textContent = msg || '';
  el.style.color = isError ? '#b91c1c' : 'inherit';
}

function setResultVisibility(root, visible) {
  const result = root.querySelector('[data-tracking-result]');
  if (!result) return;
  result.classList.toggle('is-visible', visible);
  result.setAttribute('aria-hidden', visible ? 'false' : 'true');
}

function renderResult(root, payload) {
  const result = root.querySelector('[data-tracking-result]');
  if (!result) return;

  const hasMeaningfulData = Boolean(
    payload
    && (payload.order_number || payload.tracking_number || (Array.isArray(payload.steps) && payload.steps.length))
  );
  if (!hasMeaningfulData) {
    setResultVisibility(root, false);
    return;
  }
  setResultVisibility(root, true);

  const sanitizeOptions = {
    redactCountry: root.dataset.redactCountry || 'China',
    facilityLabel: root.dataset.facilityLabel || 'Jeanity Warehouse',
    blockedPhrases: parseBlockedPhrases(root.dataset.blockedPhrases),
    replacementRules: parseReplacementRules(root.dataset.replacementRules),
  };

  // eslint-disable-next-line no-console

  root.querySelector('[data-order-number]').textContent = `Order ${text(payload.order_number, '')}`;
  root.querySelector('[data-status]').textContent = sanitizeDisplayText(payload.status, sanitizeOptions) || 'Unknown';
  root.querySelector('[data-current-status]').textContent = sanitizeDisplayText(payload.status, sanitizeOptions) || 'Unknown';
  const trackingNumEl = root.querySelector('[data-tracking-number]');
  if (trackingNumEl) trackingNumEl.textContent = text(payload.tracking_number, '—');

  const lmNum = text(payload.carrier_details?.last_mile_tracking_number);
  const hasLastMile = Boolean(lmNum && lmNum.toLowerCase() !== text(payload.tracking_number).toLowerCase());
  const carrierEl = root.querySelector('[data-carrier]');
  if (carrierEl) carrierEl.hidden = true;
  renderCarrierBadges(root, payload, sanitizeOptions);

  const orderDateEl = root.querySelector('[data-order-date-line]');
  if (orderDateEl) {
    orderDateEl.textContent = payload.order_date
      ? `Order Placed: ${formatShortDate(payload.order_date)}`
      : '';
    orderDateEl.hidden = !payload.order_date;
  }
  const shippingMethodEl = root.querySelector('[data-shipping-method-line]');
  if (shippingMethodEl) {
    shippingMethodEl.textContent = payload.shipping_method
      ? `Shipping: ${payload.shipping_method}`
      : '';
    shippingMethodEl.hidden = !payload.shipping_method;
  }
  const estDeliveryEl = root.querySelector('[data-est-delivery-line]');
  if (estDeliveryEl) {
    const isDelivered = text(payload.status_code).toLowerCase().includes('deliver');
    if (isDelivered) {
      estDeliveryEl.textContent = '';
      estDeliveryEl.hidden = true;
    } else if (payload.estimated_delivery_by) {
      estDeliveryEl.textContent = `*Latest Expected Delivery Date: ${formatShortDate(payload.estimated_delivery_by)}`;
      estDeliveryEl.hidden = false;
    } else {
      estDeliveryEl.textContent = 'Latest expected delivery is 20 business days after payment is processed';
      estDeliveryEl.hidden = false;
    }
  }

  const shipToText = buildAddress(payload.shipped_to)
    .split('\n')
    .map((line) => sanitizeDisplayText(line, sanitizeOptions))
    .filter(Boolean)
    .join('\n');
  root.querySelector('[data-ship-to]').textContent = shipToText;

  renderProduct(root, payload.products || payload.product);
  renderProgress(root, payload);
  renderTimeline(root, payload.steps || [], sanitizeOptions);
  renderMap(root, payload);
}

async function requestTracking(root, body) {
  const endpoint = root.dataset.endpoint || '/apps/jeanity-track';
  const demoMode = root.dataset.demoMode === 'true';

  if (demoMode) {
    await new Promise((resolve) => setTimeout(resolve, 350));
    return DEMO_RESPONSE;
  }

  const response = await fetch(endpoint, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'same-origin',
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    throw new Error(`Tracking request failed (${response.status})`);
  }

  return response.json();
}

function bindTracking(root) {
  setResultVisibility(root, false);

  const orderForm = root.querySelector('[data-form="order"]');
  const trackingForm = root.querySelector('[data-form="tracking"]');

  const loader = root.querySelector('[data-tracking-loader]');

  function showLoader() {
    setMessage(root, '');
    setResultVisibility(root, false);
    if (loader) {
      loader.removeAttribute('hidden');
      loader.style.display = 'flex';
    }
  }

  function hideLoader() {
    if (loader) {
      loader.style.display = 'none';
      loader.setAttribute('hidden', '');
    }
  }

  const handleSubmit = async (mode, fields) => {
    showLoader();
    try {
      const payload = await requestTracking(root, { mode, ...fields });
      hideLoader();
      if (!payload || payload.success === false) {
        setResultVisibility(root, false);
        setMessage(root, text(payload?.message, 'No tracking information found for those details.'), true);
        return;
      }

      renderResult(root, payload);
      setMessage(root, '');

      const tn = text(payload.tracking_number);
      if (tn) {
        const url = new URL(window.location.href);
        url.searchParams.set('tracking-number', tn);
        history.replaceState(null, '', url.toString());
      }
    } catch (error) {
      hideLoader();
      setResultVisibility(root, false);
      setMessage(root, 'Unable to fetch tracking right now. Please try again in a moment.', true);
    }
  };

  orderForm?.addEventListener('submit', (event) => {
    event.preventDefault();
    const fd = new FormData(orderForm);
    handleSubmit('order_lookup', {
      order_number: text(fd.get('order_number')).trim(),
      contact: text(fd.get('contact')).trim(),
    });
  });

  trackingForm?.addEventListener('submit', (event) => {
    event.preventDefault();
    const fd = new FormData(trackingForm);
    handleSubmit('tracking_lookup', {
      tracking_number: text(fd.get('tracking_number')).trim(),
    });
  });

  const initialTn = new URLSearchParams(window.location.search).get('tracking-number');
  if (initialTn && trackingForm) {
    const tnInput = trackingForm.querySelector('[name="tracking_number"]');
    if (tnInput) tnInput.value = initialTn;
    handleSubmit('tracking_lookup', { tracking_number: initialTn.trim() });
  }
}

document.querySelectorAll('[data-jeanity-tracking]').forEach((root) => {
  bindTracking(root);
});